import classNames from "classnames/bind";
import { GalleryObject } from "@/components/Galleries/utils";
import styles from "./Pips.module.scss";

const cx = classNames.bind(styles);

type PipProps = {
  media: GalleryObject[];
  selectedIndex: number;
};

export const Pips = ({ media, selectedIndex }: PipProps) => (
  <div className={styles.pipsContainer} aria-hidden="true">
    {media.map((mediaItem, index: number) => {
      const className = cx(styles.pip, {
        selectedPip: index === selectedIndex,
        video: mediaItem.type === "video",
      });

      return (
        <span
          className={className}
          key={`${mediaItem.imageUrl}-${index}`}
        ></span>
      );
    })}
  </div>
);
